export const useImage = (imageRoutes: Array<string>) => {
  let images: any = [];
  try {
    imageRoutes.forEach((imageRoute: string) => {
      const image = require(`@images/${imageRoute}`).default;
      images.push(image);
    });
  } catch (e) {
    images = [];
  }

  if (images.length === 1) return images[0];
  return images;
};
